/**
 * /api/v1/hash-kontrol/{type} servisinin dondurdugu kayit durumlarina gore
 * uretilen hata mesajlari ve bunlari geri tanima yardimcilari.
 *
 * Kayit durumlari ve silme davranisi:
 *   tevzi            -> tevzi alinmis, takip acilmamis. Hash serbestce silinebilir.
 *   odeme_deneniyor  -> odeme istegi gonderilmis, sonucu alinamamis. Takip acilmis
 *                       olabilir; hash silinebilir ama once UYAP'tan kontrol istenir.
 *   acildi           -> takip acilmis. Hash silinemez.
 *
 * Mesaj metni tek yerden uretilir ki form (hemen ac) ve islem detay ekranlari
 * ayni isaretle taniyip cop kutusu butonunu buna gore gostersin.
 */

export const TEVZI_STATUS = "tevzi";
export const ACILMIS_TAKIP_STATUS = "acildi";
export const ODEME_DENENIYOR_STATUS = "odeme_deneniyor";

/** Mesajlarin icinde tasinan tanima isaretleri. Metin degisirse burasi da guncellenmeli. */
export const ACILMIS_TAKIP_HATA_ISARETI = "Takip açılmış.";
export const ODEME_DENENIYOR_HATA_ISARETI = "Ödeme sonucu alınamadı.";

/** Silme onay diyaloglarinda gosterilen uyari. */
export const ODEME_DENENIYOR_SILME_UYARISI =
    "Bu takip için ödeme denenmiş, sonucu alınamamıştır. Takibin UYAP'ta açılmadığından " +
    "emin olmadan silmeyiniz; aksi halde aynı borç için ikinci bir takip açılabilir.";

export interface AcilmisTakipBilgisi {
    icraDairesi: string;
    dosyaEsasNo: string;
}

/** hash-kontrol cevabindaki data alaninin kullandigimiz kismi. */
export interface HashKontrolKayit {
    dosya?: any | null;
    status?: string | null;
    icra_dairesi?: string | null;
    dosya_esas_no?: string | null;
}

export function isAcilmisTakipKaydi(data?: HashKontrolKayit | null): boolean {
    return data?.status === ACILMIS_TAKIP_STATUS;
}

export function isOdemeDeneniyorKaydi(data?: HashKontrolKayit | null): boolean {
    return data?.status === ODEME_DENENIYOR_STATUS;
}

export function acilmisTakipBilgisiOlustur(data?: HashKontrolKayit | null): AcilmisTakipBilgisi {
    return {
        icraDairesi: (data?.icra_dairesi ?? "").toString().trim(),
        dosyaEsasNo: (data?.dosya_esas_no ?? "").toString().trim()
    };
}

export function acilmisTakipHataMesaji(bilgi: AcilmisTakipBilgisi): string {
    const detay = [
        bilgi.icraDairesi ? "İcra Dairesi: " + bilgi.icraDairesi : "",
        bilgi.dosyaEsasNo ? "Esas No: " + bilgi.dosyaEsasNo : ""
    ].filter(parca => parca !== "").join(" - ");

    if (detay === "")
        return ACILMIS_TAKIP_HATA_ISARETI + " Takip açıldığı için hash silinemez.";

    return ACILMIS_TAKIP_HATA_ISARETI + " " + detay + ". Takip açıldığı için hash silinemez.";
}

export function odemeDeneniyorHataMesaji(): string {
    return ODEME_DENENIYOR_HATA_ISARETI +
        " Takibin açılıp açılmadığını UYAP'tan kontrol ediniz. Açılmışsa hash'i silmeyiniz.";
}

/**
 * Bir hata/aciklama metninin "takip zaten acilmis" hatasi olup olmadigini soyler.
 * Gorev kaydinda sadece description (error.message) saklandigi icin detay
 * ekranlari bu kontrolu metin uzerinden yapar.
 */
export function isAcilmisTakipHatasi(message?: string | null): boolean {
    return typeof message === "string" && message.includes(ACILMIS_TAKIP_HATA_ISARETI);
}

/** Metnin "odeme denenmis, sonucu bilinmiyor" hatasi olup olmadigini soyler. */
export function isOdemeDeneniyorHatasi(message?: string | null): boolean {
    return typeof message === "string" && message.includes(ODEME_DENENIYOR_HATA_ISARETI);
}
